const WeatherActionTypes = {
	FETCH_WEATHER_REQUEST: "FETCH_WEATHER_REQUEST",
	FETCH_WEATHER_RECEIVE: "FETCH_WEATHER_RECEIVE",
	FETCH_WEATHER_FAILURE: "FETCH_WEATHER_FAILURE"
};

export default WeatherActionTypes;
